import { getLink } from '../../../../utils/utils';

const content = {
	rus: (
		`
		<div class="poem mb-5">
			<p class="poem-block mb-3">
				Some say the world will end in fire,<br/>
				Some say in ice.<br/>
				From what I've tasted of desire<br/>
				I hold with those who favor fire.<br/>
				But if it had to perish twice,<br/>
				I think I know enough of hate<br/>
				To say that for destruction ice<br/>
				Is also great<br/>
				And would suffice.
			</p>
		</div>


		<div class="poem">
			<p class="poem-block mb-3 text-center bold">
				Огонь и Лёд
			</p>

			<p class="poem-block mb-3">
				Кто говорит, что мир поглотит пламя,<br/>
				Кто говорит, что будет весь он скован льдами.<br/>
				Поскольку он горел в огне желаний,<br/>
				Мне огненный конец был бы желанней.<br/>
				Но если б нужно было дважды умереть,<br/>
				Во льду бы я вторую встретил смерть.<br/>
				Ведь ненависть, холодная, как лёд,<br/>
				Вернее мир к погибели ведёт.
			</p>

		</div>
		`
	)
}

const itemName = {
	rus: 'Fire and Ice'
}

const item = {
	itemlink: getLink(itemName.rus),
	rus:{
		itemName: itemName.rus,
		itemContent: content.rus,
		itemAuthor: "Роберт Фрост <br/> Перевод Татьяны Аудерской",
	}
}

export default item;